import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';
import { selectPerPage } from '../selectors/general.js';

export const fetchSickLeaveStatistics = createAsyncThunk(
    'sickLeaveStats/fetchStatistics',
    async ({ page, query }, { getState, rejectWithValue }) => {
        try {
            const perPage = selectPerPage(getState());
            const { statistics, summaryDays, maxPageNumber } = await API.sickLeaves.get(page, perPage, query);

            const state = getState().sickLeaveStatistics;

            const payload = page
                ? {
                      statistics: [...state.statistics, ...statistics],
                      summaryDays: state.summaryDays + summaryDays,
                  }
                : {
                      statistics,
                      summaryDays,
                  };

            return {
                ...payload,
                maxPageNumber,
            };
        } catch (error) {
            notification.error({ message: 'ERROR', description: error.message });
            return rejectWithValue(error.message);
        }
    },
);
